import { FormatHeader5Icon } from './FormatHeader5Icon';

/**
 * author: Austin Andrews
 * id FFC1FF08-CEFF-4623-B715-4731CDEF27D4
 * name format-header-5
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-5.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeading5Icon = FormatHeader5Icon;
export default FormatHeading5Icon